import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#323338",
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_8553",
		"data-name": "Path 8553",
		d: "M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm-.4,4.25-7.07,4.42a1.011,1.011,0,0,1-1.06,0L4.4,8.25a.849.849,0,1,1,.9-1.44L12,11l6.7-4.19a.849.849,0,1,1,.9,1.44Z",
		transform: "translate(-2 -4)"
	})
});
export { SvgEmail as ReactComponent };
